import { createTranslations } from '@npco/utils-translations'

export const translations = createTranslations({
  description: 'There are no items that meet your criteria.',
  title: 'No Items found',
})
